export const useMenu = (pathname) => {
  // Exact match, or prefix of a deeper URL — except a module index
  // (`/app/{slug}`). That path is a prefix of every module sub-route, so a
  // naive startsWith() keeps "Dashboard" highlighted on Campaigns/Audiences.
  const isActive = (path) => {
    if (!path) return false;
    if (path === '/') return pathname === '/';
    if (pathname === path) return true;
    if (!pathname.startsWith(path + '/')) return false;
    const segs = path.split('/').filter(Boolean);
    if (segs.length === 2 && segs[0] === 'app') return false;
    return true;
  };

  const hasActiveChild = (children) => {
    if (!children || !Array.isArray(children)) return false;
    return children.some(
      (child) =>
        (child.path && isActive(child.path)) ||
        (child.children && hasActiveChild(child.children)),
    );
  };

  const isItemActive = (item) => {
    return (
      (item.path ? isActive(item.path) : false) ||
      (item.children ? hasActiveChild(item.children) : false)
    );
  };

  const getCurrentItem = (items) => {
    let best;
    const walk = (nodes) => {
      for (const item of nodes || []) {
        if (item.path && isActive(item.path)) {
          if (!best || item.path.length > best.path.length) best = item;
        }
        if (item.children && item.children.length > 0) walk(item.children);
      }
    };
    walk(items);
    return best;
  };

  const getBreadcrumb = (items) => {
    const findBreadcrumb = (nodes, breadcrumb = []) => {
      let best = breadcrumb;
      for (const item of nodes) {
        const currentBreadcrumb = [...breadcrumb, item];

        if (item.path && isActive(item.path)) {
          if (currentBreadcrumb.length >= best.length) best = currentBreadcrumb;
        }

        if (item.children && item.children.length > 0) {
          const childBreadcrumb = findBreadcrumb(
            item.children,
            currentBreadcrumb,
          );
          if (childBreadcrumb.length > best.length) {
            best = childBreadcrumb;
          }
        }
      }
      return best;
    };

    const breadcrumb = findBreadcrumb(items);
    return breadcrumb.length > 0 ? breadcrumb : [];
  };

  const getChildren = (items, level) => {
    const hasActiveChildAtLevel = (nodes) => {
      for (const item of nodes) {
        if ((item.path && isActive(item.path)) ||
          (item.children && hasActiveChildAtLevel(item.children))) {
          return true;
        }
      }
      return false;
    };

    const findChildren = (nodes, targetLevel, currentLevel = 0) => {
      for (const item of nodes) {
        if (item.children) {
          if (
            targetLevel === currentLevel &&
            hasActiveChildAtLevel(item.children)
          ) {
            return item.children;
          }
          const children = findChildren(
            item.children,
            targetLevel,
            currentLevel + 1,
          );
          if (children) {
            return children;
          }
        } else if (
          targetLevel === currentLevel &&
          item.path &&
          isActive(item.path)
        ) {
          return nodes;
        }
      }
      return null;
    };

    return findChildren(items, level);
  };

  return {
    isActive,
    hasActiveChild,
    isItemActive,
    getCurrentItem,
    getBreadcrumb,
    getChildren,
  };
};
